<template>
</template>

<script>
export default {
  name: 'CoolingUnitCallConfigQuery',
  props: ['height', 'chartType', 'queryColumns', 'queryResult', 'setupToken', 'queryID', 'queryParams', 'queryMeta', 'embedded', 'selected'],

  data() {
    return {
      center: {lat: 48.30639, lng: 14.28611},
    }
  },

  methods: {},

  async mounted() {

    if (this.selected[0]) {
      let paramList = []
      for (let key in this.selected[0]) {
        if (key.startsWith("__")) continue   // internal vue field - ignore it
        let param = {name: key, value: this.selected[0][key]}
        paramList.push(param)
      }

      console.warn("Call Plugin 'CoolingUnitCallConfigQuery'.", paramList)

      switch (this.selected[0].propSerie) {
        case "SLXi-Serie":
          this.$emit('reloadSubquery', {
            id: '{4C99DED1-DF3E-11EB-B8BB-309C23AC5997}',
            detailQueryKeyValue: paramList,
            globalQueryParam: { 'qp.device_oiID': this.selected[0]["device_oiID"], 'qp.propModel':this.selected[0]["propModel"], 'qp.propSerie':this.selected[0]["propSerie"]}
          })
          break

        case "T-Serie":
          this.$emit('reloadSubquery', {
            id: '{A82AF4E1-E0C5-11EB-B8BB-309C23AC5997}',
            detailQueryKeyValue: paramList,
            globalQueryParam: { 'qp.device_oiID': this.selected[0]["device_oiID"], 'qp.propModel':this.selected[0]["propModel"], 'qp.propSerie':this.selected[0]["propSerie"]}
          })
          break
      }
    }
  }
}

</script>

